module.exports = __webpack_public_path__ + "img/shizuoka.684be40b.jpg";